// extracted by mini-css-extract-plugin
module.exports = {"md":"history_md_3MpkR","ios":"history_ios_3WCkg","page":"history_page_1pdzx","empty":"history_empty_-SSvk","preloader":"history_preloader_33OHr"};